import { FC, ReactNode } from 'react'
import { cn } from '@/utilities/cn'

type Props = {
  value: number
  max: number
  children: ReactNode
}

const ProgressBar: FC<Props> = ({ value, max, children }) => {
  const percentage = Math.max(2, max === 0 ? 0 : (value / max) * 100)
  return (
    <div className={'relative w-full h-8 p-1 rounded-full border-primary border-2 overflow-hidden'}>
      <div
        className={cn(
          'h-full bg-primary rounded-l-full',
          percentage < 4 ? 'rounded-r-md' : 'rounded-r-full',
        )}
        style={{ width: percentage + '%' }}
      ></div>
      <div
        className={
          'absolute top-0 w-full h-full px-2 flex items-center justify-start text-sm font-semibold'
        }
      >
        {children}
      </div>
    </div>
  )
}

export default ProgressBar
